// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"fa36350f","313":"356d0c6f","596":"c7168325"}[chunkId] + ".chunk.js";
};